module.exports = __webpack_public_path__ + "static/media/AI.af88b86f.svg";